import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  *:focus-visible {
    outline: 3px solid rgba(59, 158, 212, 0.35);
    outline-offset: 3px;
  }

  html {
    scroll-behavior: smooth;
    scroll-padding-top: 96px;
  }

  html, body, #root {
    min-height: 100%;
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #FAFEFF;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    color: #2D4A5E;
    line-height: 1.6;
  }

  body, input, button, textarea {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 16px;
  }

  body.menu-open {
    overflow: hidden;
  }

  a {
    text-decoration: none;
    color: #3B9ED4;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  a:hover {
    color: #2178AB;
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
    border: none;
    background: transparent;
    font: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  input,
  textarea,
  button {
    font: inherit;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  /* Selection color */
  ::selection {
    background: rgba(59, 158, 212, 0.18);
    color: #2178AB;
  }

  /* Scrollbar Frutiger Aero Pastel Style */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #EBF6FC;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #6BBDDF 0%, #A8D8F0 100%);
    border-radius: 10px;
    border: 2px solid #EBF6FC;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #3B9ED4 0%, #6BBDDF 100%);
  }

  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }

    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;
